export default __webpack_public_path__ + "static/media/insideout-desktop.e4a6c9d1.png";